<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>指挥中心</el-breadcrumb-item>
			<el-breadcrumb-item>生产状况查询</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="时间范围">
					<DateRange v-model="dateRange" />
				</el-form-item>
				<el-form-item label="车间选择" v-show="!userWorkshopId">
					<el-select v-model="workshop" placeholder="车间选择" :clearable="true">
						<el-option v-for="item in workshops" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="机台选择">
					<el-select placeholder="机台选择" v-model="jt_id" :clearable="true">
						<el-option :label="item.label" :value="item.value" v-for="item in jt_list" :key="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="info" v-on:click="search">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div>
			<el-table border :data="tableData" v-loading="tableLoading" style="width: 100%" :default-sort="{ prop: 'start_time_str' }">
				<el-table-column type="index" width="60" label="序号"></el-table-column>
				<el-table-column prop="workshop_name" label="车间" width="120"></el-table-column>
				<el-table-column prop="jt_name" label="设备" width="120"></el-table-column>
				<el-table-column prop="product_name" width="100" label="产品"></el-table-column>
				<el-table-column prop="code" label="工单" width="100" sortable></el-table-column>
				<el-table-column prop="yieldRate" :formatter="yieldRateFormat" label="良品率" width="80"></el-table-column>
				<el-table-column prop="adjustLength" :formatter="adjustLengthFormat" label="调机米数" width="120"></el-table-column>
				<el-table-column prop="start_time_str" label="开始时间" width="180" sortable></el-table-column>
				<el-table-column prop="end_time_str" label="结束时间" width="180" sortable></el-table-column>
				<el-table-column prop="unprocess_serious_defect_count" label="未处理严重度" align="center" width="120"></el-table-column>
				<el-table-column prop="current_process" label="当前工序" width="120"></el-table-column>
				<el-table-column prop="next_process" label="下一工序" width="100"></el-table-column>
				<el-table-column prop="jt_status_str" label="工作状态" align="center" width="120"></el-table-column>
				<el-table-column label="工序" align="center">
					<el-table-column :label="'工序-' + (index + 1)" align="center" width="100" v-for="(item, index) in processList" :key="index">
						<template slot-scope="scope">
							<span v-text="getProcessInfo(scope.row, index)"></span>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column label="缺陷分布" width="120" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" icon="el-icon-s-data" @click="handleViewStat(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!--分页-->
			<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import dictionaryData from '@/service/dictionaryData'
	import jobOrderService from '@/service/jobOrderService'
	import processService from '@/service/processService'
	import { mapGetters } from 'vuex'
	import { workshopRequest } from '@/network/requests/workshop'

	export default {
		components: {
			DateRange,
		},
		data() {
			return {
				dateRange: [],
				tableData: [],
				tableLoading: false,
				processList: [],
				workshops: [],
				workshop: '',
				workshopInfo: {},
				jt_id: '',
				jt_list: [],
				jt_data: [],
				pageSize: 10,
				pageCount: 1,
				pageIndex: 1,
				loopInterval: null,
				changing: false,
				interval: 15000,
			}
		},
		computed: {
			...mapGetters(['userWorkshopId']),
		},
		watch: {
			workshop(val) {
				this.jt_list = this.jt_data.filter(t => t.workshop == val)
				if (this.jt_list.length > 0) {
					this.jt_id = this.jt_list[0].value
				} else {
					this.jt_id = ''
				}
			},
		},
		methods: {
			/**
			 * 调机米数格式化。
			 */
			adjustLengthFormat(row, column, cellValue, index) {
				var val = cellValue / 1000
				return val + ' 米'
			},
			/**
			 * 良率格式化。
			 */
			yieldRateFormat(row, column, cellValue, index) {
				return cellValue + '%'
			},
			/**
			 * 获取查询用的参数。
			 */
			getFilter() {
				var filter = {
					jt_id: this.jt_id,
					workshop_id: this.workshop,
				}

				if (this.dateRange) {
					if (this.dateRange.length > 0) {
						filter.start_time_start = this.dateRange[0]
						filter.start_time_end = this.dateRange[1]
					}
				}

				//如果只查询车间，则清空机台Id。
				if (this.workshop) {
					filter.jt_id = ''
				}

				//如果查询条件都没有，则直接返回未定义，避免参数查询。
				if (!filter.jt_id && !filter.workshop_id && (!filter.start_time_start || !filter.start_time_end)) return undefined

				return filter
			},
			/**
			 * 搜索。
			 */
			search() {
				this.tableLoading = true
				this.pageIndex = 1
				this.query()
			},
			/**
			 * 查询。
			 */
			query() {
				clearInterval(this.loopInterval)

				var q = () => {
					var filter = this.getFilter()

					jobOrderService.getJobOrderStatusList(this.pageIndex, this.pageSize, filter).then(result => {
						this.tableData = result.data
						this.pageCount = result.pageCount

						setTimeout(() => {
							this.tableLoading = false
						}, 1000)
					})
				}

				q()

				this.loopInterval = setInterval(() => {
					q()
				}, this.interval)
			},
			/**
			 * 切换页码。
			 */
			handleCurrentChange(page) {
				this.tableData = []
				this.tableLoading = true
				this.pageIndex = page

				this.query()
			},
			/**
			 * 修改每页记录数量。
			 */
			handleSizeChange(size) {
				this.tableLoading = true
				this.pageIndex = 1
				this.pageSize = size
				this.query()
			},
			/**
			 * 查看缺陷分布。
			 */
			handleViewStat(row) {
				console.log(row)
				this.$router.push({
					name: 'production_defect',
					query: { job_order_id: row._id.$oid },
				})
			},
			/**
			 * 查看工序信息
			 */
			getProcessInfo(row, index) {
				var p = ''
				var process_list = row.process_list
				if (process_list) {
					var result = process_list.find(t => t.sequence == index + 1)
					if (result) {
						p = result.name
					}
				}

				return p
			},
		},
		async created() {
			this.tableLoading = true
			var jt_filter = undefined

			if (this.userWorkshopId) {
				this.workshop = this.userWorkshopId
				this.workshopInfo = (await workshopRequest.getDocumentById(this.userWorkshopId)).data
				jt_filter = { workshop_id: this.userWorkshopId }
			} else {
				//获取所有车间。
				this.workshops = await dictionaryData.getWorkshops()
			}

			//机台。
			this.jt_data = await dictionaryData.getJTList(jt_filter)
			this.jt_list = this.jt_data

			//获取所有工序。
			this.processList = await processService.getProcessList()

			//查询工单状态。
			this.query()
		},
		destroyed() {
			clearInterval(this.loopInterval)
		},
	}
</script>

<style></style>
